export const AUTHOR_CHANGED = "post/author";
export const CATEGORY_CHANGED = "post/category";
export const SEARCH_BLOGS = "search/post/title";
